var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('div',{staticClass:"profile-container"},[_c('ProfileHeader'),_c('ProfileStats'),_c('div',{staticClass:"container-nav"},[_c('ProfileFilterNav')],1),_c('div',{staticClass:"container-content"},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }